import React, { useState, useEffect, useRef, useCallback } from "react";
import Form from "react-bootstrap/Form";
import Col from "react-bootstrap/Col";
import MaskedInput from "react-text-mask";
import { toast } from "react-toastify";
import Swal from "sweetalert2";
import Bunexe_service from "../../../Bunexe_service";

const SaisieNotes = ({ info_ }) => {
  const symbRef = useRef(null);

  const [numero_correction, setNumero_Correction] = useState("1");
  const [symbolique, setSymbolique] = useState("");
  const [info, setInfo] = useState({});
  const [authorisation] = useState(false);
  const [messageTotal] = useState("");
  const [note, setNote] = useState("");

  const url_ = Bunexe_service.url;

  const setFocus = (champId) => {
    const el = document.getElementById(champId);
    if (el) el.focus();
  };

  const RechercherNoteParSymbolique = useCallback(async () => {
    if (symbolique.length !== 12) return;

    try {
      const response = await fetch(
        `${url_}/saisie_notes_bac/${symbolique}/${numero_correction}`,
      );
      const data = await response.json();

      if (data.erreur) {
        toast.error(data.msg);
        setInfo({});
      } else if (data[0]?.symbolique) {
        setInfo(data[0]);

        const noteFinale = parseInt(data[0].Note_Finale, 10);
        const hasNoNote = data[0].Note.trim() === "" && noteFinale === 0;

        if (hasNoNote || authorisation || info_?.role_id === "ADM") {
          setFocus("note");
        } else {
          const messageErreur = `Cette note existe déjà. La note pour la matière ${data[0].Libelle_Matiere} est ${parseInt(data[0].Note, 10)}`;
          toast.error(messageErreur, { position: toast.POSITION.TOP_RIGHT });
          setSymbolique("");
          setInfo({});
          setFocus("symbolique");
        }
      }
    } catch (error) {
      console.error("Erreur lors de la recherche de la symbolique :", error);
      toast.error("Erreur de communication avec le serveur");
    }
  }, [symbolique, numero_correction, url_, authorisation, info_]);

  const validerNote = async (not_) => {
    if (!info_?.username || info_.username === "NULL") {
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "Il semble que vous devez vous reconnecter à la plateforme bunexe.work",
        footer: "<h6>Prière de vous reconnecter à la plateforme</h6>",
      });
      return;
    }

    let prog = "3";
    if (symbolique.startsWith("8")) prog = "1";
    else if (symbolique.startsWith("2")) prog = "2";

    const formData = {
      symbolique,
      numero_correction,
      note_: not_,
      utilisateur: info_.username,
      prog,
    };

    try {
      const response = await fetch(`${url_}/saisie_notes_bac/ajouter_note`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(formData),
      });

      const data = await response.json();

      if (data.msg === "OK") {
        setSymbolique("");
        setNote("");
        setInfo({});
        setFocus("symbolique");
      } else {
        toast.error("Erreur de mise à jour de la note", {
          position: toast.POSITION.TOP_RIGHT,
        });
      }
    } catch (error) {
      console.error("Erreur validation note :", error);
      toast.error("Erreur de connexion au serveur");
    }
  };

  const handleNoteValidation = (valeur) => {
    const noteVal = parseInt(valeur, 10);

    if (isNaN(noteVal) || noteVal < 2 || noteVal > 100) {
      toast.error("La note doit être comprise entre 002 et 100", {
        position: toast.POSITION.TOP_RIGHT,
      });
      setFocus("note");
      return;
    }

    if (noteVal % 2 !== 0) {
      toast.error("La note doit être paire", {
        position: toast.POSITION.TOP_RIGHT,
      });
      setFocus("note");
      return;
    }

    validerNote(valeur);
  };

  useEffect(() => {
    setFocus("symbolique");
  }, []);

  return (
    <div className="container justify-content-center">
      <div className="row justify-content-md-center mt-4 mx-1">
        <div className="col-xs-11 col-sm-11 col-md-6 border rounded py-3">
          {messageTotal && (
            <h6 className="text-right font-italic">{messageTotal}</h6>
          )}

          <h4 className="text-right font-italic text-primary">
            {info.Libelle_Matiere
              ? `${info.Libelle_Matiere} : ${info.Note || 0}`
              : "\u00A0"}
          </h4>
          <hr />

          <Form autoComplete="off" onSubmit={(e) => e.preventDefault()}>
            <Form.Row>
              <div className="d-flex justify-content-between w-100 mb-2">
                <div className="form-check">
                  <input
                    className="form-check-input"
                    type="radio"
                    name="numero_correction"
                    id="correction1"
                    value="1"
                    checked={numero_correction === "1"}
                    onChange={() => {
                      setNumero_Correction("1");
                      setInfo({});
                      setFocus("symbolique");
                    }}
                  />
                  <label className="form-check-label" htmlFor="correction1">
                    Correction 1
                  </label>
                </div>

                <div className="form-check mr-4">
                  <input
                    className="form-check-input"
                    type="radio"
                    name="numero_correction"
                    id="correction2"
                    value="2"
                    checked={numero_correction === "2"}
                    onChange={() => {
                      setNumero_Correction("2");
                      setInfo({});
                      setFocus("symbolique");
                    }}
                  />
                  <label className="form-check-label" htmlFor="correction2">
                    Correction 2
                  </label>
                </div>

                <div className="form-check">
                  <input
                    className="form-check-input"
                    type="radio"
                    name="numero_correction"
                    id="correction3"
                    value="3"
                    checked={numero_correction === "3"}
                    onChange={() => {
                      setNumero_Correction("3");
                      setInfo({});
                      setFocus("symbolique");
                    }}
                  />
                  <label className="form-check-label" htmlFor="correction3">
                    Correction 3
                  </label>
                </div>
              </div>
            </Form.Row>
            <hr />

            <Form.Row className="mt-3">
              <Form.Group as={Col} controlId="symbolique">
                <Form.Label>Symbolique</Form.Label>
                <MaskedInput
                  mask={[
                    /\d/,
                    /\d/,
                    /\d/,
                    /\d/,
                    /\d/,
                    /\d/,
                    /\d/,
                    /\d/,
                    /\d/,
                    /\d/,
                    /\d/,
                    /\d/,
                  ]}
                  className="form-control"
                  placeholder="Symbolique"
                  value={symbolique}
                  ref={symbRef}
                  name="symbolique"
                  id="symbolique"
                  guide={false}
                  onChange={(e) => setSymbolique(e.target.value)}
                  onKeyPress={(e) => {
                    if (e.key === "Enter" || e.target.value.length === 12) {
                      RechercherNoteParSymbolique();
                    }
                  }}
                  onBlur={(e) => {
                    if (e.target.value.length === 12)
                      RechercherNoteParSymbolique();
                  }}
                />
              </Form.Group>

              <Form.Group as={Col} controlId="note">
                <Form.Label>Note</Form.Label>
                <MaskedInput
                  mask={[/\d/, /\d/, /\d/]}
                  className="form-control"
                  placeholder="Note"
                  value={note}
                  name="note"
                  id="note"
                  guide={false}
                  onChange={(e) => setNote(e.target.value)}
                  onFocus={() => {
                    if (symbolique.trim().length < 12) {
                      setFocus("symbolique");
                      toast.error(
                        "La symbolique est obligatoire et doit comporter 12 chiffres",
                        {
                          position: toast.POSITION.TOP_RIGHT,
                        },
                      );
                    }
                  }}
                  onKeyPress={(e) => {
                    if (e.key === "Enter" && e.target.value.length >= 3) {
                      handleNoteValidation(e.target.value);
                    }
                  }}
                />
              </Form.Group>
            </Form.Row>
          </Form>
        </div>
      </div>
    </div>
  );
};

export default SaisieNotes;
